import { Fragment } from 'react';

import { Sidebar as HygraphSidebarProps } from '@/lib/types';

import Separator from '@/components/separator';

import { Spacing } from '@/enums/spacing';
import { getRenderer, getRendererData } from '@/hygraph/renderers';

export default function SidebarRenderer(props: unknown) {
  const hygraphProps = props as HygraphSidebarProps;

  if (
    !hygraphProps.sidebarComponents ||
    hygraphProps.sidebarComponents.length === 0
  ) {
    return <></>;
  }

  return (
    <>
      {hygraphProps.sidebarComponents.map((component, c) => {
        const Renderer = getRenderer(component.__typename);
        if (!Renderer) return <></>;

        const componentProps = getRendererData({
          ...component,
          index: c,
          isInSidebar: true,
        });

        return (
          <Fragment key={c}>
            <Renderer {...componentProps} />
            <Separator spacing={Spacing.SMALL} />
          </Fragment>
        );
      })}
    </>
  );
}
